// T-222 lato BO: collegamento dell'account quando un admin entra con Google
// ma la sua email ha gia' un account con un altro metodo (Firebase "un account
// per email" -> auth/account-exists-with-different-credential).
//
// I testi sono gli stessi approvati per l'app (mobile-app/src/auth/accountLinking.js).

export const LINK_ERROR = {
  cancelled: 'LINK_CANCELLED',
  emailMismatch: 'LINK_EMAIL_MISMATCH',
  noPending: 'LINK_NO_PENDING',
  inFlight: 'LINK_IN_FLIGHT',
} as const;

export class LinkError extends Error {
  readonly code: string;
  readonly actualEmail: string | null;

  constructor(code: string, actualEmail: string | null = null) {
    super(code);
    this.code = code;
    this.actualEmail = actualEmail;
  }
}

export function sameEmail(a: string | null | undefined, b: string | null | undefined): boolean {
  const x = String(a ?? '').trim().toLowerCase();
  const y = String(b ?? '').trim().toLowerCase();
  return x !== '' && x === y;
}

export function isAccountExistsError(e: unknown): boolean {
  return (e as { code?: string } | null)?.code === 'auth/account-exists-with-different-credential';
}

// L'admin ha chiuso il popup di Google: non e' un errore da mostrare.
export function isPopupCancelled(e: unknown): boolean {
  const code = (e as { code?: string } | null)?.code;
  return code === 'auth/popup-closed-by-user' || code === 'auth/cancelled-popup-request';
}

/**
 * Testo da mostrare per un errore del collegamento. `null` = nessun messaggio.
 * Mai il messaggio grezzo di Firebase.
 */
export function linkErrorMessage(e: unknown, email?: string | null): string | null {
  const err = e as { code?: string; actualEmail?: string | null } | null;
  switch (err?.code ?? '') {
    case LINK_ERROR.cancelled:
    case LINK_ERROR.inFlight:
      return null;
    case LINK_ERROR.emailMismatch:
      return `Hai scelto un account con un'altra email${err?.actualEmail ? ` (${err.actualEmail})` : ''}. Usa quello con ${email ?? "l'email indicata"}.`;
    case LINK_ERROR.noPending:
      return 'Il collegamento non è più disponibile. Torna all’accesso e riprova.';
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
    case 'auth/invalid-login-credentials':
      return 'Password errata.';
    case 'auth/credential-already-in-use':
      return 'Questo metodo di accesso è già collegato a un altro account.';
    case 'auth/too-many-requests':
      return 'Troppi tentativi. Riprova tra qualche minuto.';
    case 'auth/network-request-failed':
      return 'Connessione assente. Controlla la rete e riprova.';
    default:
      return 'Collegamento non riuscito. Riprova.';
  }
}
